import { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";

export function toE164Phone(value, defaultCountry = "LY") {
  const phone = String(value || "").trim();
  if (!phone) return "";

  const compact = phone.replace(/[\s()-]/g, "");
  const international = compact.startsWith("00")
    ? `+${compact.slice(2)}`
    : compact.startsWith("+")
      ? compact
      : /^\d{8,15}$/.test(compact) && !compact.startsWith("0")
        ? `+${compact}`
        : compact;

  try {
    return parsePhoneNumber(international, defaultCountry)?.number || international;
  } catch {
    return international;
  }
}

export function phoneForApi(value, defaultCountry = "LY") {
  return toE164Phone(value, defaultCountry).replace(/\D/g, "");
}

export function isInternationalPhoneValid(value, defaultCountry = "LY") {
  const normalized = toE164Phone(value, defaultCountry);
  return Boolean(normalized && isValidPhoneNumber(normalized));
}

export function normalizePhoneList(value, defaultCountry = "LY") {
  return String(value || "")
    .split(/[\n,]+/)
    .map((phone) => phone.trim())
    .filter(Boolean)
    .map((phone) => ({
      original: phone,
      normalized: phoneForApi(phone, defaultCountry),
      valid: isInternationalPhoneValid(phone, defaultCountry),
    }));
}
